import Vue from "vue";
import Vuex from "vuex";
import { mutations } from "./mutations";
import actions from "./actions";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentUser: JSON.parse(window.localStorage.getItem("currentUser")),
    showMenu: false,
    product_variations: false,
    cart: JSON.parse(window.localStorage.getItem("cart")) || [],
    banner: {
      title: "Biobá, produtos da natureza.",
      subtitle: "Articulação comercial pela biodiversidade",
    },
    activeOrder: null,
    newChatRequest: null,
  },
  actions,
  mutations,
});
